import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-magic",
  "use": "icon-magic-usage",
  "viewBox": "0 0 58 58",
  "content": "<symbol viewBox=\"0 0 58 58\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-magic\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M50 0h2v6h6v2h-6v6h-2V8h-6V6h6V0zM37.9 21.2l-1.4-1.4-2.9 2.9 1.5 1.4 2.8-2.9zm0-2.8L36.5 17 35 18.4l-2.9 2.8-1.4 1.5 1.4 1.4 1.4 1.4 1.5 1.4 1.4-1.4 2.8-2.8 1.4-1.5-1.4-1.4-1.4-1.4zm-8.5 5.7l4.2 4.2L5.4 56.6A3 3 0 111 52.4L29.4 24zM32 2h-2v4h-4v2h4v4h2V8h4V6h-4V2zm18 20h2v4h4v2h-4v4h-2v-4h-4v-2h4v-4z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol